export const ColorScheme = {
    "palettes": [
        {
            "id": "palette1",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette2",
            "ranges": ["#F5CBCB", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette3",
            "ranges": ["#D4C2F9", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette4",
            "ranges": ["#FFD79A", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette5",
            "ranges": ["#CFCFCF", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette6",
            "ranges": ["#00BE66", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette7",
            "ranges": ["#FFDD63", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette8",
            "ranges": ['#ECF6FF', '#CCCCCC', '#FFBD59', '#FFD23F', '#000000']
        }
    ],
    "themes": [
        {
            "id": "colorTheme1",
            "name": "colorTheme1",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette1"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette1"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
                {
                    "type": "count",
                    "ranges": ["palette1"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette1"]
                },
                {
                    "type": "birthdayReminder",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedGuage",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedGuageDial",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette8"]
                }
            ]
        },
        {
            "id": "colorTheme2",
            "name": "colorTheme2",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette2"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette2"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette2"]
                }
            ]
        },
        {
            "id": "colorTheme3",
            "name": "colorTheme3",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette3"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette3"]
                },
            ]
        },
        {
            "id": "colorTheme4",
            "name": "colorTheme4",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette4"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette4"]
                },
            ]
        },
        {
            "id": "colorTheme5",
            "name": "colorTheme5",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette5"]
                },
            ]
        },
        {
            "id": "colorTheme6",
            "name": "colorTheme6",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette6"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette6"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette6"]
                }
            ]
        }
    ]
}
